<template>
<div id="wrapper" class="solarpet">
<!--   <ProgressHUD
    ref="progress"
    :display="true"
  /> -->

  <layout-main>
    <div
      id="page-content-wrapper"
    >
        <!-- <div
          v-if="data && data.project && data.project.confirmed == false"
          class="container"
        >
            <div class="row">
                <div class="col-lg-12">
                    <div class="alert alert-danger" role="alert">In the near time we will check this project</div>
                </div>
            </div>
        </div>

        <div
          v-if="data && data.project && data.project.draft"
          class="container"
        >
            <div class="row">
                <div class="col-lg-12">
                    <div class="alert alert-danger" role="alert">This project saved in draft</div>
                </div>
            </div>
        </div> -->

        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <h4 class="page-header">Project</h4>
            </div>
          </div>
          <div class="row solarpet-box">
              <div class="col-lg-12">
                  <div class="row top-row cm-box-info">
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <div class="panel-green pg-table1">
                        <div class="panel-content">
                          <div class="sd-grapg-content">
                            ProjectSite Daily Production for date: 2019-12-05 <table>
                              <thead>
                                <tr>
                                  <th >
                                    InverterId
                                  </th>
                                  <th >
                                    InverterName
                                  </th>
                                  <th >
                                    Production
                                  </th>
                                  <th >
                                    Prediction
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(item, key) in inverter">
                                  <td >{{item.inverter_id}}</td>
                                  <td >{{item.name}}</td>
                                  <td >{{item.production.toFixed(2)}}</td>
                                  <td >{{item.prediction.toFixed(2)}}</td>
                                </tr>                               
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <div class="panel-green pg-table2">
                        <div class="panel-content">
                          <div class="sd-grapg-content">
                             <br>
                            <datepicker :value="date" @input="log" min="2019-12-05" max="2020-01-31" :dayStr="dayStr" :scrollbarProps="{isMobile: true}" :popperProps="popperProps"/>
                             <table>
                                <thead>
                                  <tr>
                                    <th >Inverter</th><th>Health History Old->New 15 days</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr >
                                    <td>INVERTER D </td><td> ABDDGCACDFDDGGF</td>
                                  </tr>  
                                  <tr ><td>INVERTER B </td><td> AAAAGDCAAADBGFD </td></tr>
                                  <tr ><td>  INVERTER F  </td><td>  AADDGBFCBBFEGGF</td></tr>
                                  <tr ><td>  INVERTER C  </td><td>  AEDCGACCEAABGFG</td></tr>
                                  <tr ><td>  INVERTER E  </td><td> AADCGAC*AACBGFE</td></tr>
                                  <tr ><td> INVERTER A  </td><td>  AAAEGCAADEAEGFD</td></tr>
                                  </tr>
                                </tbody>
                              </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <div class="panel-green pg-table3">
                        <div class="panel-content">
                          <div class="sd-grapg-content">
                            ACPower per time (kW)
                            <line-chart
                                  :chart-data="linecollection"
                                  :options="{
                                              responsive: true,
                                              legend: {
                                                display: true,
                                                position: 'top',

                                                },                                               
                                              maintainAspectRatio: false,
                                              scales: {
                                                yAxes: [{
                                                  ticks: {
                                                    beginAtZero:true
                                                  }
                                                }]
                                              }
                                            }"
                                  :width="533"
                                  :height="320"
                                ></line-chart>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <div class="panel-green pg-table4">
                        <div class="panel-content">
                          <div class="sd-grapg-content">
                            Actual vs. Predicted Energy Chart

                            <bar-chart
                                  :chart-data="barcollection"
                                  :options="{
                                              responsive: true,                                      
                                              maintainAspectRatio: false,                                              
                                              scales: {
                                                yAxes: [{
                                                  ticks: {
                                                    beginAtZero:true
                                                  }
                                                }]
                                              }
                                            }"
                                  :width="533"
                                  :height="320"
                                ></bar-chart>
                          </div>

                            


                        </div>
                      </div>
                    </div>
                  </div>
              </div>
          </div>

         
        </div>
    </div>
  </layout-main>
</div>
</template>
<script>
import LayoutMain from './../../../../layouts/LayoutMain.vue';
import ProgressHUD from './../../../ProgressHUD/index.vue'
import Footer from './../../../Footers/Footer/index.vue'
import LineChart from './LineChart.js'
import BarChart from './BarChart.js'
import { Api, Toast } from './../../../../services'

export default {
  name: 'SolarPet',

  props: [],
  components: {
    LayoutMain,
    ProgressHUD,
    Footer,
    LineChart,
    BarChart,
    // 'datepicker': VueDatepicker.Datepicker
  },
  data() {
    return {
      solarpetdata: null,
      datalines: null,
      inverters: null,      
      barcollection: {
        labels: [],
        actualData: [],
        predictedData: [],
      },
      linecollection: {},
      dayStr: ['7', '1', '2', '3', '4', '5', '6'],
      date: '2020-01-05',
      // isM: isM,
      popperProps: {
        arrowPosition: 'start',
        arrowOffsetScaling: 1,
        popperOptions: {
          placement: 'bottom-start',
          positionFixed: true,
          // more options in https://popper.js.org
        },
    }
  }
  },
  methods: {
    log: function (val) {
      this.date = val
      console.log(val)
    },

    parseDate(input) {
      var parts = input.split('/')
      return new Date(parts[0], parts[1] - 1, parts[2])
    },

        // Display / refresh data for chart
    refreshDataForChart() {
      if (this.solarpetdata == undefined || this.solarpetdata == null) return

      // set data for charts
      this.barcollection.labels = []
      this.barcollection.actualData = []
      this.barcollection.predictedData = []

      var timeLine = 0
      if (this.typeChart == 'week') timeLine = 7
      else timeLine = 80

      var curentDate = new Date()
      var timePeriod = {
        first: new Date(
          curentDate.getFullYear(),
          curentDate.getMonth(),
          curentDate.getDate() - timeLine
        ),
        last: new Date(
          curentDate.getFullYear(),
          curentDate.getMonth(),
          curentDate.getDate()
        ),
      }

      // Get time period for filter
      for (var i=0; i< this.solarpetdata.length; i++) {

        // console.log("this.datacollection>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 2 ")
        // console.log(this.solarpetdata[i])

        var ipvDataByDay = this.solarpetdata[i]
        // if (!ipvDataByDay) {
        //   console.error('IPV Data is null')
        //   continue
        // }

        //var ivpDate = this.parseDate(ipvDataByDay.TimeStamp)

        //if (timePeriod.first <= ivpDate && ivpDate <= timePeriod.last) {
          this.barcollection.labels.push(ipvDataByDay.Hour)
          this.barcollection.actualData.push(ipvDataByDay.Production)
          this.barcollection.predictedData.push(ipvDataByDay.Prediction)
        //}
      }
      // console.log("this.datacollection>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 1")
      // console.log(this.barcollection)

      this.barcollection = this.createDataCollection(
        this.barcollection.labels,
        this.barcollection.actualData,
        this.barcollection.predictedData
      )
    },

    createDataCollection(labels, actualData, predictedData) {

      return {
        labels: labels,
        datasets: [
          {
            label: 'Actual',
            backgroundColor: 'rgba(91, 155, 213, 0.2)',
            borderColor: 'rgba(91, 155, 213, 1)',
            borderWidth: 1,
            data: actualData,
          },
          {
            label: 'Predicted',
            backgroundColor: 'rgba(237, 125, 49, 0.2)',
            borderColor: 'rgba(237, 125, 49,1)',
            borderWidth: 1,
            data: predictedData,
          },
        ],
      }
    },

    refreshDataForChart2() {
      if (this.datalines == undefined || this.datalines == null) return

      var datasets = [], labels = [], colors = ['rgba(91, 155, 213, 0.6)', 'rgba(237, 125, 49, 0.6)', 'rgba(66, 185, 131, 0.6)', 'rgba(11, 107, 251, 0.6)', 'rgba(251, 11, 88, 0.6)', 'rgba(168, 15, 247, 0.6)'];    
      var labelNumber = 0, max = this.datalines[0]['hour'].length;
      for (var i=0; i< this.datalines.length; i++) {
        console.log("this.datacollection LENGTH >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 2 ")
        console.log(this.datalines[i]['hour'].length)
        var invID = this.datalines[i]['inverter_id'];
        // console.log(this.datalines[i]['inverter_id'])
        datasets[i] = { 
                        label: this.datalines[i]['inverter_id'],
                        fill: false, 
                        backgroundColor: colors[i],
                        borderColor: colors[i],
                        data: this.datalines[i]['data'] 
                      }
        if (this.datalines[i]['hour'].length > max) {
          max = this.datalines[i]['hour'].length;
          labelNumber = i;
        }  
        // labelNumber[i] = this.datalines[i]['hour'].length

    }
    labels = this.datalines[labelNumber]['hour'];
    //for (var ii=0; ii< 40; ii++)  labels[ii] = ii;
      this.linecollection = {
                            labels: labels, 
                            datasets: datasets
                          };
    },
  },
  async created() {
    try {

      var response = await Api.getSolarpet(this.$route.params.id)
      var resline = await Api.getSolarpetLine(this.$route.params.id)
      this.solarpetdata = response.data.solarpet[0].data["2019-12-05"];
      this.inverter =  response.data.res;
      this.datalines = resline.data.arrInvs;
      console.log( "<<<<<<<<<<<<<<<<<<<<<< this.data ******* >>>>>>>>>>>>>>>>>" )
      // console.log( response.data.solarpet[0].data )
      console.log( resline )

      // await new Promise(resolve => this.$nextTick(resolve))

      this.refreshDataForChart()
      this.refreshDataForChart2()

    } catch (error) {
      console.error(error)

      Toast.error({
        toast: this.$toast,
        title: 'Error',
        message: error.message,
      })
    } finally {
      // this.$refs.progress.hide()
    }
  },
}
</script>
    



// WEBPACK FOOTER //
// src/components/Project/SystemsDetail/ProjectExisting/SolarPet.component.vue